import {PUB_SUB_EVENTS, publish} from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { subscribe, type SubscriberCallback } from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import {type CartDrawer} from '@/scripts/cart/cart-drawer'

export class QuantityInput extends UcoastEl {
	static htmlSelector = 'quantity-input'
	input: HTMLInputElement
	changeEvent: Event
	quantityUpdateUnsubscriber: SubscriberCallback | undefined = undefined
	// cart: CartDrawer

  get shouldSendValueUpdateEvent(): boolean {
    return this.getAttribute('send-value-update-event') !== 'false';
  }

	constructor() {
		super()
		this.input = q.rs('input', this)
		this.changeEvent = new Event('change', { bubbles: true })

		this.input.addEventListener('change', this.onInputChange.bind(this))
		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onButtonClick.bind(this))
		)
		// this.cart = q.rs<CartDrawer>('cart-drawer')

		// notify subscribers on init
		this.onInputChange();
	}


	override connectedCallback() {
		this.validateQtyRules()
		this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityRangeUpdate, this.validateQtyRules.bind(this))
	}

	override disconnectedCallback() {
		if (this.quantityUpdateUnsubscriber) {
			this.quantityUpdateUnsubscriber(undefined)
		}
	}

	onInputChange(_event?: Event) {
		this.validateQtyRules()
		if (this.shouldSendValueUpdateEvent) {
		publish(PUB_SUB_EVENTS.quantityValueUpdate, {
			source: 'quantity-change',
			data: {
			quantity: parseInt(this.input.value),
			},
		});
		}
	}

	onButtonClick(event: Event) {
		event.preventDefault()
		const previousValue = this.input.value
		const target = q.rt<Event, HTMLButtonElement>(event)
		const direction = target.name === 'plus' ? 1 : -1
		const currentIncrementMaybe = q.oa(target, 'data-uc-quantity-current-increment')
		const currentIncrement = currentIncrementMaybe ? parseInt(currentIncrementMaybe) : undefined
		const previousIncrementMaybe = q.oa(target, 'data-uc-quantity-previous-increment')
		const previousIncrement = previousIncrementMaybe ? parseInt(previousIncrementMaybe) : undefined
		const nextIncrementMaybe = q.oa(target, 'data-uc-quantity-next-increment')
		const nextIncrement = nextIncrementMaybe ? parseInt(nextIncrementMaybe) : undefined

    	let newValue: number;
		if (currentIncrement && previousIncrement && nextIncrement) {
			if (direction === 1) {
				newValue = nextIncrement
			} else if (parseInt(previousValue) === currentIncrement) {
				// step down to previous increment to avoid reducing by quantity of 4
				newValue = previousIncrement
			} else {
				newValue = parseInt(previousValue) - currentIncrement
			}
		} else {
			if (direction === 1) {
				newValue = parseInt(previousValue) + 1
			} else {
				newValue = parseInt(previousValue) - 1
			}
		}

		// ensure new value is in the boundaries
		const { min, max } = this.boundaries;
		if (newValue < min) {
			newValue = min;
		}
		if (newValue > max) {
			newValue = max;
		}

		this.updateQuantityOfCartItems(newValue, previousValue);

	}

	validateQtyRules() {
		const value = parseInt(this.input.value)
    	const {min, max} = this.boundaries;
		if (this.input.min) {
			const buttonMinus = q.rs(".quantity__button[name='minus']", this)
			buttonMinus.classList.toggle('disabled', value <= min)
		}
		if (this.input.max) {
			const buttonPlus = q.rs(".quantity__button[name='plus']", this)
			buttonPlus.classList.toggle('disabled', value >= max)
		}
	}

	updateQuantityOfCartItems(newValue: number, previousValue: string) {

		let child: HTMLElement | undefined;
		let parent: HTMLElement | undefined;

		const refillVariantId = this.input.getAttribute('data-uc-refill-variant-id')
		const parentVariantId = this.input.getAttribute('data-uc-parent-variant')

		if (!refillVariantId && !parentVariantId) {
			console.log('No parent or child')
			this.input.value = newValue.toString();

			if (previousValue !== this.input.value) {
				this.input.setAttribute('value', this.input.value)
				this.input.dispatchEvent(this.changeEvent)
			}
		} else {
			if (refillVariantId) {
				const childEl = q.os(`input[data-uc-quantity-input][data-quantity-variant-id="${refillVariantId}"]`)
				if (childEl) {
					child = childEl;
				}
				parent = this.input;
			} else {
				const parentEl = q.os(`input[data-uc-quantity-input][data-quantity-variant-id="${parentVariantId}"]`)
				if (parentEl) {
					parent = parentEl
				}
				child = this.input
			}

			if (parent && child) {
				const childKey = q.ra(child, 'data-uc-cart-item-key')
				const parentKey = q.ra(parent, 'data-uc-cart-item-key')
				let updates = {
					[childKey]: newValue,
					[parentKey]: newValue,
				}
				fetch(window.routes.cart_update_url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: `application/json`,
						'X-Requested-With': 'XMLHttpRequest',
					},
					body: JSON.stringify({ updates, sections: 'cart-drawer,cart-icon-bubble' })
				})
				.then((response) => response.json()).then((response) => {
					if (response.status || response.errors) {
						console.error(response.description)
					} else {
						const cart: CartDrawer = q.rs('cart-drawer')
						cart.renderContents(response)
					}
				})
			}
		}
	}

  get boundaries(): { min: number, max: number} {
    return {
      min: parseInt(this.input.min ?? '0'),
      max: parseInt(this.input.max ?? '0'),
    };
  }
}
